import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  makeStyles,
  MessageBar,
  MessageBarBody,
  Spinner,
  Text,
  tokens
} from "@fluentui/react-components";
import { useCommand } from "@tdp/core";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    margin: "12px 0px 24px 0px",
    display: "flex",
    gap: "18px",
    flexDirection: "column",
  },
  errorBody: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    overflowY: "auto"
  }
});

export const AppListTakeOwnershipDialog: React.FC<{
  open: boolean;
  setOpen: (value: boolean) => void,
}> = ({ open, setOpen }) => {

  const navigate = useNavigate();
  const classes = useStyles();
  const intl = useIntl();

  const takeOwnership = useCommand((commands) => commands.appListCommands.takeOwnership);


  const [isTakingOwnership, takingOwnership] = React.useState(false);
  const [appId, setAppId] = React.useState<string>('');

  const onCancel = () => {
    setOpen(false);
  };

  const onClick = () => {
    takingOwnership(true);
    takeOwnership({
      appId: appId,
      onCallback: () => { navigate(`/apps/${appId}/dashboard`); setOpen(false) },
      onFailure: () => { onCancel(); }
    })
  }

  const Alert = () => {
    return (
      <div>
        <MessageBar intent="warning">
          <MessageBarBody style={{ color: tokens.colorNeutralForeground1 }}>
            <Text>
              {intl.formatMessage({ defaultMessage: "As a tenant admin, you can take control of the apps that have been created or are currently published in your organization." })}
            </Text>
          </MessageBarBody>
        </MessageBar>
      </div>
    )
  }

  const isValidGUID = (guid: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(guid);

  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{intl.formatMessage({ defaultMessage: "Take ownership" })}</DialogTitle>
          <DialogContent className={classes.container}>
            <Alert />
            <Field label={intl.formatMessage({ defaultMessage: "App ID" })} required>
              <Input
                type="text"
                placeholder={'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'}
                disabled={isTakingOwnership}
                value={appId}
                onChange={(e) => setAppId(e.target.value)}
              />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => { onCancel() }} disabled={isTakingOwnership}>
              {intl.formatMessage({ defaultMessage: "Cancel" })}
            </Button>
            <Button
              appearance="primary"
              icon={isTakingOwnership ? <Spinner size="tiny" /> : null}
              disabled={isTakingOwnership || !isValidGUID(appId)}
              onClick={onClick}
            >
              {intl.formatMessage({ defaultMessage: "Recover" })}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}